import React, { useRef } from 'react'
import TourNavigator from './TourNavigator_/TourNavigator'
import TourHelper from './TourHelper'
import TourHelperTwo from './TourHelperTwo'


export default function Test2() {
    const tourNavigatorRef = useRef<TourNavigator>(null)

   
  return (
    <div style={{background: 'lightgreen', overflow: 'hidden'}} id='container'>
        <div id='scrolling-container' style={{padding: 10, overflow: 'auto', background: 'white', height: 300, width: 300, margin: '100px auto'}}>
            <p style={{color: 'black', margin: 0}}>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos in placeat reiciendis dolor hic consectetur sed corporis? Mollitia praesentium nostrum error? Adipisci, doloremque est nulla cum dignissimos sit incidunt ipsam!
            </p>
            <div id="box-1" style={{height: 500, width: '100%', background: 'red', margin: '50px auto'}}></div>
            <div id="box-2" style={{height: 100, width: 100, background: 'blue', margin: '50px auto'}}></div>
            <div id="box-3" style={{height: 100, width: 100, background: 'green', margin: '50px auto'}}></div>
        </div>
        <div id="box-4" style={{height: 100, width: 100, background: 'purple', margin: '1000px auto auto auto'}}></div>
        
        <TourNavigator
            ref={tourNavigatorRef}
            steps={[
                {
                    selector: 'p',
                    data: {title: 'P tag', description: 'P tag description'},
                    intersectionOption: {threshold: .1}
                },
                {
                    selector: '#box-1',
                    data: {title: 'Box 1', description: 'Box description'},
                    container: '#scrolling-container'
                },
                {
                    selector: '#box-2',
                    data: {title: 'Box 2', description: 'Box description'}
                },
                {
                    selector: '#box-3',
                    data: {title: 'Box 3', description: 'Box description'},
                },
                {
                    selector: '#box-4',
                    data: {title: 'Box 4', description: 'Box description'},
                }
            ]}
            helper={TourHelperTwo}
            overlayOpacity={.8}
            scrollBehavior='smooth'
            // style={{pointerEvents: 'none'}}
        />
    </div>
  )
}
